import React from 'react'

import RecipePageWrapper from '../../../react4xp/components/RecipePageWrapper'
import SingleVideo from '../../../react4xp/components/SingleVideo'

function RecipeLayout({
	title,
	intro,
	image,
	video,
	textLabel,
	instructions,
	tips,
	time,
	portions,
	ingredients,
	allergens,
	tracesOf,
	strings,
	bgColor,
	isWhite
}) {
    return (
		<>
			<RecipePageWrapper
				topPart={{
					bgColor: bgColor,
					whiteText: isWhite,
					image: {
						src: image?.src,
						srcMedium: image?.srcMedium,
						alt: image?.alt
					},
					title: title,
					difficulty: textLabel,
					time: time,
					desc: intro
				}}
				ingredients={{
					sectionTitle: strings.ingredientsHeader,
					portions,
					items: ingredients
				}}
				howTo={{
					sectionTitle: strings.instructionsHeader,
					content: instructions
				}}
				allergens={{
					allergensTitle: strings.allergensHeader,
					allergensItems: allergens,
					tracesOfTitle: strings.tracesOfHeader,
					tracesOfItems: tracesOf
				}}
				tips={{
					sectionTitle: strings.tipsHeader,
					content: tips
				}}
			/>

			{
				video && (
					<SingleVideo
						title={strings.videoTutorial}
						video={{
							url: video.url,
							playText: strings.videoPlayText,
							videoType: video.videoType,
							poster: video.poster,
							posterMedium: video.posterMedium,
							cookieConsentHtml: video.cookieConsentHtml,
						}}
					/>
				)
			}
		</>
    )
}

export default (props) => <RecipeLayout {...props} />
